import React from "react";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Portal />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </HashRouter>
            <Toaster theme="dark" position="bottom-right" />
        </div>
    );
}

export default App;
